<template>
  <button
    id="payu-button"
    :disabled="sendingOrder"
    class="next-step-button button">
      <div class="loader"><div></div><div></div><div></div><div></div></div>
      Przejdź do płatności
  </button>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'RecurringPaymentButton',
  computed: {
    ...mapState([
      'user',
      'sendingOrder'
    ]),
    ...mapGetters([
      'getSummary'
    ])
  },
  mounted: function () {
    let totalAmount = this.getSummary.totalPriceGross.toFixed(2).toString()
    let sigUrl = process.env.VUE_APP_PAYMENTS_SERVICE_HOST + process.env.VUE_APP_PAYMENTS_SERVICE_GENERATE_SIG_PATH
    axios.post(sigUrl, {
      'currency-code': 'PLN',
      'customer-email': this.user.email,
      'customer-language': 'pl',
      'merchant-pos-id': process.env.VUE_APP_PAYU_MERCHANT_POS_ID,
      'shop-name': 'Kcalmar',
      'total-amount': totalAmount
    }).then((response) => {
      let puScript = document.getElementById('payu-script')
      if (puScript !== null) {
        puScript.remove()
      }

      puScript = document.createElement('script')
      puScript.setAttribute('src', process.env.VUE_APP_PAYU_WIDGET_URL)
      puScript.setAttribute('id', 'payu-script')
      puScript.setAttribute('success-callback', 'payUCallback')
      puScript.setAttribute('sig', response.data.sig)
      puScript.setAttribute('pay-button', '#payu-button')
      // Sig required attributes
      puScript.setAttribute('merchant-pos-id', process.env.VUE_APP_PAYU_MERCHANT_POS_ID)
      puScript.setAttribute('customer-email', this.user.email)
      puScript.setAttribute('total-amount', totalAmount)
      puScript.setAttribute('shop-name', 'Kcalmar')
      puScript.setAttribute('currency-code', 'PLN')
      puScript.setAttribute('customer-language', 'pl')
      puScript.setAttribute('store-card', 'true')
      puScript.setAttribute('recurring-payment', 'true')
      puScript.setAttribute('payu-brand', 'true')
      puScript.setAttribute('widget-mode', 'use')
      document.body.appendChild(puScript)
    })
  }
}
</script>
